var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleRightNofill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7121 12.0002L9.70111 5.99023L8.28711 7.40423L12.8871 12.0042L8.28711 16.5972L9.70111 18.0112L15.7121 12.0002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRightNofill);
export default __webpack_public_path__ + "static/media/AngleRight_nofill.2edf6413aa597f62b4f5d54a26708eec.svg";
export { ForwardRef as ReactComponent };